/**
 * Maps country names and ISO-3166 codes to date format convention.
 * Used during upload to resolve ambiguous slash dates (both parts ≤ 12).
 *
 * Returns "MDY" for US/Canada, "DMY" for all other known countries, null for unknown.
 */
const MDY_COUNTRIES = new Set(["United States", "USA", "US", "Canada", "CA"]);

export function getDateFormatForCountry(country) {
  if (!country) return null;
  const trimmed = String(country).trim();
  if (!trimmed) return null;
  if (MDY_COUNTRIES.has(trimmed)) return "MDY";
  return "DMY";
}

/** Resolve registered country from list-sitelocation data by site location id/name. */
export function getCountryForSiteLocation(siteLocations, siteLocationId) {
  if (!siteLocationId) return null;
  const list = Array.isArray(siteLocations) ? siteLocations : [];
  const id = String(siteLocationId).trim();
  const site = list.find((s) => s?.name === id || s?.siteLocationId === id);
  const country = site?.country;
  return country ? String(country).trim() : null;
}

/**
 * Returns a human-readable label for a format hint.
 * e.g. "DMY" → "DD/MM/YYYY"
 */
export function formatHintLabel(hint) {
  if (hint === "MDY") return "MM/DD/YYYY";
  if (hint === "DMY") return "DD/MM/YYYY";
  return null;
}
